import { render, staticRenderFns } from "./wesScanTask.vue?vue&type=template&id=0b6b148a&scoped=true"
import script from "./wesScanTask.vue?vue&type=script&lang=js"
export * from "./wesScanTask.vue?vue&type=script&lang=js"
import style0 from "./wesScanTask.vue?vue&type=style&index=0&id=0b6b148a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6b148a",
  null
  
)

export default component.exports